import { ScheduledMaintenanceBanner } from './scheduled-maintenance-banner';

export function SiteBanners() {
  return (
    <div className="shrink-0">
      <ScheduledMaintenanceBanner />
    </div>
  );
}
